export enum BmAttachmentType {
  bodManagementPresentation = 'BOD_Management_Presentation',
  techReview = 'Pre-Board_Technical_Review',
  financialStatement = 'Financial_Statement',
  icMemoCompanyFormation = 'IC_Memo_Company_Formation',
  icMemoNewDeal = 'IC_Memo_New_Deal',
  icMemoInterimUpdate = 'IC_Memo_Interim_Update',
  icMemoCompanyExit = 'IC_Memo_Company_Exit',
  llcAgreement = 'LLC_Agreement',
  llcAgreementAmendment = 'LLC_Agreement_Amendment',
  technicalEvalSupport = 'Technical_Eval_Support',
}

export const IcMemoCategoryMap: Record<BmAttachmentType, string> = {
  [BmAttachmentType.icMemoCompanyFormation]: 'Company Formation',
  [BmAttachmentType.icMemoNewDeal]: 'New Deal',
  [BmAttachmentType.icMemoInterimUpdate]: 'Interim Update',
  [BmAttachmentType.icMemoCompanyExit]: 'Company Exit',
  [BmAttachmentType.bodManagementPresentation]: "",
  [BmAttachmentType.techReview]: "",
  [BmAttachmentType.financialStatement]: "",
  [BmAttachmentType.llcAgreement]: "",
  [BmAttachmentType.llcAgreementAmendment]: "",
  [BmAttachmentType.technicalEvalSupport]: ""
};
